import { render, staticRenderFns } from "./invite_friends.vue?vue&type=template&id=36ba9f86&scoped=true"
import script from "./invite_friends.vue?vue&type=script&lang=js"
export * from "./invite_friends.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ba9f86",
  null
  
)

export default component.exports